<template>
<div class="title-wrapper">
    <div class="title" v-if="isHome"><a href="#" @click.prevent="goStart">{{ title }}</a></div>
    <div class="title" v-if="!isHome"><router-link :to="{name: 'home', 'hash': 'welcome'}">{{ title }}</router-link></div>
    <div class="bid-logo">
      <a href="https://www.iadb.org/" target="_blank">
      <svg width="56px" height="22px" viewBox="0 0 56 22" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <title></title>
        <defs>
          <polygon id="path-1"
            points="0.0424305556 0.0546430769 12.9457611 0.0546430769 12.9457611 13.9399867 0.0424305556 13.9399867">
          </polygon>
          <polygon id="path-3"
            points="4.45451624e-06 0.0615034483 21.9416391 0.0615034483 21.9416391 20.7878569 4.45451624e-06 20.7878569">
          </polygon>
        </defs>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="HEADER-Copy-3" transform="translate(-300.000000, -12.000000)">
            <rect id="Rectangle" fill="#E5DBD0" x="0" y="0" width="373" height="43"></rect>
            <text id="Una-historia-en-un-m" font-family="Helvetica" font-size="18" font-weight="normal"
              line-spacing="19" fill="#005073">
              <tspan x="14" y="29">Una hi</tspan>
              <tspan x="66.03125" y="29" letter-spacing="-0.18">s</tspan>
              <tspan x="74.85125" y="29" letter-spacing="-0.27">t</tspan>
              <tspan x="79.5822266" y="29">oria en un millón</tspan>
            </text>
            <g id="BID-Copy" transform="translate(300.000000, 12.000000)">
              <path
                d="M28.3449229,8.48792355 L28.3449229,6.04435011 L31.087751,6.04435011 C31.8864053,6.04435011 32.8383425,6.24900074 32.8383425,7.22686447 L32.8383425,7.26573868 C32.8383425,8.07637815 32.1835317,8.48792355 30.8926438,8.48792355 L28.3449229,8.48792355 Z M31.690572,13.9555775 L28.3449229,13.9555775 L28.3449229,11.3960329 L31.5929821,11.3960329 C32.9222088,11.3960329 33.5964796,11.8198849 33.5964796,12.6562957 L33.5964796,12.6953147 C33.5964796,13.5318703 32.9554649,13.9555775 31.690572,13.9555775 L31.690572,13.9555775 Z M34.7059838,9.65234005 C35.7388103,8.95477603 36.2417904,8.00579649 36.2417904,6.76211135 L36.2417904,6.72316475 C36.2417904,5.73675883 35.9159098,4.93263458 35.2451244,4.26453388 C34.415465,3.43724437 33.1325645,3 31.5351833,3 L25,3 L25.0006535,17 L31.690572,17 C35.0644669,17 37,15.5652014 37,13.0634976 L37,13.025275 C37,11.4162302 36.2889152,10.3627898 34.7059838,9.65234005 L34.7059838,9.65234005 Z"
                id="Fill-1" fill="#005073"></path>
              <g id="Group-5" transform="translate(43.000000, 3.000000)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-4"></g>
                <path
                  d="M9.40604167,6.99656103 L9.40604167,7.03504308 C9.40604167,9.31273538 7.85109722,10.8434738 5.53695278,10.8434738 L3.44705833,10.8434738 L3.44705833,3.15101231 L5.53695278,3.15101231 C7.85109722,3.15101231 9.40604167,4.69610974 9.40604167,6.99656103 M5.53695278,0.0546430769 L0.0424305556,0.0546430769 L0.0458972222,13.9399867 L5.53695278,13.9391969 C7.627425,13.9391969 9.52383611,13.2275662 10.8783639,11.9354738 C12.2119472,10.6633405 12.9457972,8.90903282 12.9457972,6.99656103 L12.9457972,6.95786359 C12.9457972,2.95802769 9.82940833,0.0546430769 5.53695278,0.0546430769"
                  id="Fill-3" fill="#005073" mask="url(#mask-2)"></path>
              </g>
              <path
                d="M39.4993636,3.00043356 C40.3277969,3.00043356 41,3.76284414 41,4.70351904 L41,17 L38,17 L38,3 L39.4993636,3.00043356 Z"
                id="Fill-6" fill="#005073"></path>
              <g id="Group-10">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-3"></use>
                </mask>
                <g id="Clip-9"></g>
                <path
                  d="M15.9923082,8.29751049 C15.52265,8.27751112 15.4388272,8.56940161 16.1438715,8.72280182 C17.1395108,8.93935417 16.4617576,8.31779659 15.9923082,8.29751049 M14.5190741,7.15897987 C13.107593,6.68838531 14.0363968,7.8513596 14.7081627,7.92841812 C15.3792323,8.00475981 15.5192386,7.49258949 14.5190741,7.15897987 M10.3628842,6.10653975 C9.9514981,6.32897005 10.6877323,7.31302522 12.5708905,7.36571175 C14.4547449,7.41925845 12.0264601,5.20714142 10.3628842,6.10653975 M13.9823019,20.350681 C14.5745614,19.2161646 15.864207,17.5617362 18.6213082,14.2265719 C22.7443589,9.23826953 10.5262829,10.9134141 8.43259304,7.13826368 C6.70809937,4.02775187 13.1256943,1.79212303 17.0034728,0.06149628 C19.5244222,1.77219534 21.3536247,4.53899032 21.8245361,7.85723755 C22.6307386,13.5263788 19.1941437,18.824779 13.9823019,20.350681 M11.5298589,12.3104313 C9.79972595,15.194857 15.3577892,15.2382965 12.7862259,20.62802 C12.7108272,20.6408511 12.6360551,20.6559044 12.5591247,20.6672302 C6.56482089,21.5708578 0.99436519,17.300024 0.116732278,11.1281744 C-0.298831013,8.20145615 0.416656329,5.37344445 1.92101076,3.11215333 C1.64113734,9.62492408 13.1456753,9.61768416 11.5298589,12.3104313"
                  id="Fill-8" fill="#005073" mask="url(#mask-4)"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScrollTitle',
  props: {
    title: {
      required: true,
      type: String
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goStart() {
      console.log('start!')
      this.$emit('start')
    }
  }
}
</script>
